/* eslint-disable import/no-cycle */
/* eslint-disable object-shorthand */
import * as Sentry from '@sentry/react';
import Amplify, { Auth } from 'aws-amplify';
import { NotificationManager } from 'components/common/react-notifications';
import { getCurrentUser, setCurrentUser } from '../helpers/Utils';
import api from '../helpers/Api';
import Mqtt from '../helpers/Mqtt';

const login = async (email, password) => {
  let response;
  try {
    response = await api.post('/users/login', {
      username: email,
      password: password,
      // siteCode: process.env.REACT_APP_SITECODE,
    });

    NotificationManager.success(
      'Login Success',
      'Success',
      3000,
      null,
      null,
      ''
    );

    setCurrentUser({ ...response.data.data, username: email });
  } catch (error) {
    let errorMessage = 'Login Error';
    if (error.response && error.response.data) {
      errorMessage = error.response.data.msg || errorMessage;
    }
    NotificationManager.warning(
      errorMessage,
      'Login Error',
      3000,
      null,
      null,
      ''
    );
    return {
      result: 'error',
      message: errorMessage,
    };
  }

  return true;
};

const resetPassword = async (token, password) => {
  let response;
  try {
    response = await api.post('/user/reset_password', {
      token: token,
      password: password,
    });
  } catch (error) {
    let errorMessage = '未能重設密碼';
    if (error.response && error.response.data) {
      errorMessage = error.response.data.msg || errorMessage;
    }
    return {
      result: 'error',
      msg: errorMessage,
    };
  }
  return response.data;
};

const forgetPassword = async (email) => {
  let response;
  try {
    response = await api.post('/users/forget_password', { email: email });
    NotificationManager.success(
      'Please check your email.',
      'Forgot Password Success',
      3000,
      null,
      null,
      ''
    );
  } catch (error) {
    let errorMessage = '未能發出重設密碼電郵';
    if (error.response && error.response.data) {
      errorMessage = error.response.data.msg || errorMessage;
    }
    NotificationManager.error(
      errorMessage,
      'Forgot Password Success',
      3000,
      null,
      null,
      ''
    );
    return {
      result: 'error',
      msg: errorMessage,
    };
  }
  return response.data;
};

const changePassword = async (password, newPassword) => {
  let response;
  const user = getCurrentUser();
  try {
    response = await api.post('/users/change_password', {
      username: user.username,
      password: password,
      newPassword: newPassword,
    });
    NotificationManager.success(
      'Success',
      'Change Password',
      3000,
      () => {
        // alert('callback');
      },
      null,
      ''
    );
    return response.data;
  } catch (error) {
    let errorMessage = 'Change Password Error';
    if (error.response && error.response.data) {
      errorMessage = error.response.data.message || errorMessage;
    }
    NotificationManager.error(
      response.message,
      'Error',
      5000,
      () => {
        // alert('callback');
      },
      null,
      ''
    );
    return {
      result: 'error',
      message: errorMessage,
    };
  }
};

const isLoggedIn = () => {
  try {
    return getCurrentUser() != null;
  } catch (e) {
    return false;
  }
};

const getToken = () => {
  try {
    const user = getCurrentUser();
    return user.accessToken;
  } catch (e) {
    return e;
  }
};

const logout = async () => {
  const result = await Auth.signOut();
  setCurrentUser(null);
  if (Mqtt.deviceClient) {
    Mqtt.deviceClient.end();
  }
  Mqtt.deviceClient = null;
  //  Sentry set no user
  Sentry.configureScope((scope) => scope.setUser(null));
  return result;
};

const refreshJwtToken = async (refreshToken) => {
  const response = await api.post('/users/refresh_token', {
    token: refreshToken,
  });
  // console.log(response.data);

  const user = getCurrentUser();
  user.accessToken = response.data.data.accessToken;
  user.refreshToken = response.data.data.refreshToken;

  setCurrentUser(user);
};

const User = {
  login,
  forgetPassword,
  resetPassword,
  changePassword,
  isLoggedIn,
  getToken,
  logout,
  refreshJwtToken,
};
export default User;
